import { TableCell, TableRow, TableFooter, Typography } from '@mui/material';

import { FORTA_BLUE, FORTA_SUCCESS } from '../../../../utils/colors';
import { usDollarFormatter } from '../../../../helpers';

interface IInvoiceClaimDetailsTableFooterProps {
  data: {
    billed: number;
    insPaid: number;
    adjustment: number;
    deductible: number;
    coIns: number;
    coPay: number;
    balanceDue: number;
    discount: number | null;
  };
  is_any_claim_paid_to_subscriber: boolean;
}

const commonCellStyles = {
  textAlign: 'right',
  color: FORTA_BLUE.primary,
};

function InvoiceClaimDetailsTableFooter({
  data,
  is_any_claim_paid_to_subscriber = false,
}: IInvoiceClaimDetailsTableFooterProps) {
  const { billed, insPaid, adjustment, deductible, coIns, coPay, balanceDue, discount } = data;
  return (
    <TableFooter>
      <TableRow>
        <TableCell colSpan={1}></TableCell>
        <TableCell colSpan={1} sx={commonCellStyles}>
          <Typography fontWeight={700} display="inline">
            Total
          </Typography>
        </TableCell>
        <TableCell colSpan={1} sx={commonCellStyles}>
          <Typography fontWeight={700} textAlign={'right'} display="inline">
            {usDollarFormatter.format(billed ?? 0)}
          </Typography>
        </TableCell>
        <TableCell colSpan={1} sx={commonCellStyles}>
          <Typography fontWeight={700} textAlign={'right'} display="inline">
            {usDollarFormatter.format(insPaid ?? 0)}
          </Typography>
        </TableCell>
        <TableCell colSpan={1} sx={commonCellStyles}>
          <Typography fontWeight={700} display="inline">
            {usDollarFormatter.format(adjustment ?? 0)}
          </Typography>
        </TableCell>
        <TableCell colSpan={1} sx={commonCellStyles}>
          <Typography fontWeight={700} display="inline">
            {usDollarFormatter.format(deductible ?? 0)}
          </Typography>
        </TableCell>
        <TableCell colSpan={1} sx={commonCellStyles}>
          <Typography fontWeight={700} display="inline">
            {usDollarFormatter.format(coIns ?? 0)}
          </Typography>
        </TableCell>
        <TableCell colSpan={1} sx={commonCellStyles}>
          <Typography fontWeight={700} display="inline">
            {usDollarFormatter.format(coPay ?? 0)}
          </Typography>
        </TableCell>
        <TableCell colSpan={1} sx={commonCellStyles}>
          <Typography fontWeight={700} display="inline">
            {usDollarFormatter.format(balanceDue ?? 0)}
          </Typography>
        </TableCell>
      </TableRow>
      {/* Discount related rows */}
      {discount !== null && discount > 0 && (
        <>
          <TableRow>
            <TableCell colSpan={8} sx={commonCellStyles}>
              <Typography fontWeight={700} color={FORTA_SUCCESS}>
                Discount
              </Typography>
            </TableCell>
            <TableCell colSpan={1} sx={commonCellStyles}>
              <Typography fontWeight={700} color={FORTA_SUCCESS}>
                {`- ${usDollarFormatter.format(discount ?? 0)}`}
              </Typography>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={8} sx={commonCellStyles}>
              <Typography fontWeight={700}>Total</Typography>
            </TableCell>
            <TableCell colSpan={1} sx={commonCellStyles}>
              <Typography fontWeight={700}>
                {usDollarFormatter.format(balanceDue - (discount ?? 0))}
              </Typography>
            </TableCell>
          </TableRow>
        </>
      )}
      {is_any_claim_paid_to_subscriber && (
        <TableRow>
          <TableCell colSpan={9}>
            <Typography fontSize={14}>
              *This amount has been paid directly to the subscriber by the insurance provider
              (payor). The subscriber is required to remit this payment to Forta as reimbursement
              for the services rendered by Forta.
            </Typography>
          </TableCell>
        </TableRow>
      )}
    </TableFooter>
  );
}

export default InvoiceClaimDetailsTableFooter;
